declare global {
  interface Window {
    AndroidBridge?: {
      acceptedCancelWinback?: () => void;
      showSupplementsSelector?: () => void;
    };
  }
}

type AndroidMessage = 'showSupplementsSelector' | 'acceptedCancelWinback';

export function androidBridge(androidMessage: AndroidMessage) {
  switch (androidMessage) {
    case 'showSupplementsSelector':
      return (
        window.AndroidBridge?.showSupplementsSelector &&
        window.AndroidBridge?.showSupplementsSelector()
      );
    case 'acceptedCancelWinback':
      return (
        window.AndroidBridge?.acceptedCancelWinback &&
        window.AndroidBridge?.acceptedCancelWinback()
      );
    default:
      return;
  }
}
